import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import './EditarRecorrido.css';

const EditarRecorrido = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recorrido, setRecorrido] = useState(null);
  const [imagenes, setImagenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    cargarRecorrido();
  }, [id]);

  const cargarRecorrido = async () => {
    try {
      const response = await api.get(`/recorridos/${id}`);
      if (response.data.success) {
        setRecorrido(response.data.recorrido);
        setImagenes(response.data.recorrido.imagenes || []);
      }
    } catch (err) {
      setError('Error al cargar recorrido');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setRecorrido({
      ...recorrido,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');

    try {
      await api.put(`/recorridos/${id}`, {
        titulo: recorrido.titulo,
        descripcion: recorrido.descripcion,
        publico: recorrido.publico
      });
      navigate('/dashboard');
    } catch (err) {
      setError('Error al guardar cambios');
    } finally {
      setSaving(false);
    }
  };

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    setSaving(true);

    for (const file of files) {
      const formData = new FormData();
      formData.append('imagen', file);
      formData.append('recorrido_id', id);
      formData.append('orden', imagenes.length);

      try {
        const response = await api.post('/panoramas/subir', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (response.data.success) {
          setImagenes([...imagenes, response.data.imagen]);
        }
      } catch (err) {
        console.error('Error al subir imagen:', err);
      }
    }

    setSaving(false);
  };

  const eliminarImagen = async (imgId) => {
    if (!window.confirm('¿Eliminar esta imagen?')) return;

    try {
      await api.delete(`/panoramas/${imgId}`);
      setImagenes(imagenes.filter(img => img.id !== imgId));
    } catch (err) {
      alert('Error al eliminar imagen');
    }
  };

  const actualizarOrden = async (nuevoOrden) => {
    try {
      await api.put(`/panoramas/recorrido/${id}/orden`, {
        imagenes: nuevoOrden
      });
    } catch (err) {
      console.error('Error al actualizar orden:', err);
    }
  };

  const moverImagen = (index, direction) => {
    const nuevasImagenes = [...imagenes];
    const nuevoIndex = direction === 'up' ? index - 1 : index + 1;
    
    if (nuevoIndex < 0 || nuevoIndex >= imagenes.length) return;

    [nuevasImagenes[index], nuevasImagenes[nuevoIndex]] = 
    [nuevasImagenes[nuevoIndex], nuevasImagenes[index]];

    setImagenes(nuevasImagenes);
    
    const ordenActualizado = nuevasImagenes.map((img, idx) => ({
      id: img.id,
      orden: idx
    }));
    
    actualizarOrden(ordenActualizado);
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  if (!recorrido) {
    return <div className="error">Recorrido no encontrado</div>;
  }

  return (
    <div className="main-content">
      <div className="container">
        <h1>Editar Recorrido</h1>
        
        {error && <div className="error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="recorrido-form">
          <div className="form-group">
            <label>Título del Recorrido *</label>
            <input
              type="text"
              name="titulo"
              value={recorrido.titulo}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={recorrido.descripcion || ''}
              onChange={handleChange}
              rows="4"
            />
          </div>
          
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                name="publico"
                checked={recorrido.publico}
                onChange={handleChange}
              />
              {' '}Hacer público este recorrido
            </label>
          </div>
          
          <div className="form-group">
            <label>Agregar Más Imágenes</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              disabled={saving}
            />
          </div>
          
          {imagenes.length > 0 && (
            <div className="imagenes-lista">
              <h3>Imágenes del Recorrido ({imagenes.length})</h3>
              {imagenes.map((img, index) => (
                <div key={img.id} className="imagen-item">
                  <div className="imagen-preview-small">
                    <img 
                      src={`${process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000'}${img.ruta_archivo}`} 
                      alt={`Panorama ${index + 1}`}
                      onError={(e) => {
                        const imagenUrl = `${process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000'}${img.ruta_archivo}`;
                        console.error('❌ [EditarRecorrido] Error cargando imagen:', {
                          ruta_archivo: img.ruta_archivo,
                          url_completa: imagenUrl,
                          imagen: img
                        });
                        e.target.src = 'https://via.placeholder.com/200x150?text=Error';
                      }}
                      onLoad={() => {
                        console.log('✅ [EditarRecorrido] Imagen cargada:', img.ruta_archivo);
                      }}
                    />
                  </div>
                  <div className="imagen-info">
                    <span>Imagen {index + 1}</span>
                    {img.nombre && <span>{img.nombre}</span>}
                  </div>
                  <div className="imagen-controls">
                    <button
                      type="button"
                      onClick={() => moverImagen(index, 'up')}
                      disabled={index === 0}
                      className="btn btn-sm"
                    >
                      ↑
                    </button>
                    <button
                      type="button"
                      onClick={() => moverImagen(index, 'down')}
                      disabled={index === imagenes.length - 1}
                      className="btn btn-sm"
                    >
                      ↓
                    </button>
                    <button
                      type="button"
                      onClick={() => eliminarImagen(img.id)}
                      className="btn btn-danger btn-sm"
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          
          <div className="form-actions">
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={saving}
            >
              {saving ? 'Guardando...' : 'Guardar Cambios'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="btn"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={() => navigate(`/visor/id/${id}`)}
              className="btn btn-success"
            >
              Ver Recorrido
            </button>
            <button
              type="button"
              onClick={() => navigate(`/editar-hotspots/${id}`)}
              className="btn btn-primary"
            >
              Editar Puntos de Interés
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditarRecorrido;

